function Enp() {
  return (
    <div>
      <div style={{ width: "100%", height: "90vh" }}>
        <iframe
          src="/enpKML.html" // your HTML file in public folder
          title="MP Garud KML Map"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default Enp;
